import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ArticleModel } from 'src/app/models/archive/article.model';
import { ItemFilterModel } from 'src/app/models/filters/item-filter.model';
import { ArticleImportModel } from 'src/app/models/imports/article-import.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { RentalStockModel } from 'src/app/models/rental/rental-stock-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private _httpClient: HttpClient) { }

  attachImage(articleId: number, imageNumber: number, file: FormData): Observable<ArticleModel> {
    return this._httpClient.post<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.AttachImagesAsync}/${articleId}/${imageNumber}`,
      file);
  }

  attachFilesToArticle(articleId: number, files: FormData): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.AttachFilesToArticle}/${articleId}`, files);
  }

  createArticle(articleContractModel: ArticleModel): Observable<ArticleModel> {
    return this._httpClient.post<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.CreateArticle}`,
      articleContractModel);
  }

  deleteArticle(articleId: number): Observable<ArticleModel> {
    return this._httpClient.delete<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.DeleteArticle}/${articleId}`);
  }

  deleteImage(articleId: number, imageNumber: number): Observable<ArticleModel> {
    return this._httpClient.post<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.DeleteImagesAsync}/${articleId}/${imageNumber}`,
      null);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.article.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportGeneralConsultationGeneric(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ExportGeneralConsultationGeneric}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllArticlesGenericForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllArticlesGenericForSelectAsync}`,);
  }

  getAllArticlesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllArticlesForSelectAsync}`,);
  }

  getAllArticlesByCompanyForSelectAsync(companyId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllArticlesByCompanyForSelectAsync}/${companyId}`,);
  }

  getArticlesEquipmentLogbookForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticlesEquipmentLogbookForSelectAsync}`,);
  }

  getAllTypeArticlesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllTypeArticlesForSelectAsync}`,);
  }

  getAllTypeInventoriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllTypeInventoriesForSelectAsync}`,);
  }

  getAllFamiliesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllFamiliesForSelectAsync}`,);
  }

  getAllSubgroupsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllSubgroupsForSelectAsync}`,);
  }

  getAllGroupsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllGroupsForSelectAsync}`,);
  }

  getAllRentalUnitsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllRentalUnitsForSelectAsync}`,);
  }

  getAllInventoryUnitsForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllInventoryUnitsForSelectAsync}`,);
  }

  getAllSuppliesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllSuppliesForSelectAsync}`,);
  }

  getAllSuppliesDevolutionForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllSuppliesDevolutionForSelectAsync}`,);
  }

  getCleaningValueByArticleId(articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetCleaningValueByArticleId}/${articleId}`);
  }

  getFirstArticleByKeysAsync(swGeneric: boolean): Observable<ArticleModel> {
    const params = new HttpParams().set('swGeneric', swGeneric);
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetFirstArticleByKeys}`,
      { params }
    );
  }

  getImageUrl(fullPath: string): Observable<Blob> {
    const params = new HttpParams().set('fullPath', fullPath);
    return this._httpClient.get(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetImagesAsync}`,
      { responseType: 'blob', params });
  }

  getLastArticleByKeysAsync(swGeneric: boolean): Observable<ArticleModel> {
    const params = new HttpParams().set('swGeneric', swGeneric);
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetLastArticleByKeys}`,
      { params });
  }

  getPreviusArticleByKeysAsync(code: number, swGeneric: boolean): Observable<ArticleModel> {
    const params = new HttpParams().set('code', code).set('swGeneric', swGeneric);
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetPreviusArticleByKeys}`,
      { params }
    );
  }

  getRepairValueByArticleId(articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetRepairValueByArticleId}/${articleId}`);
  }

  getReplacementValueByArticleId(articleId: number): Observable<number> {
    return this._httpClient.get<number>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetReplacementValueByArticleId}/${articleId}`);
  }

  getNextArticleByKeysAsync(code: number, swGeneric: boolean): Observable<ArticleModel> {
    const params = new HttpParams().set('code', code).set('swGeneric', swGeneric);
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetNextArticleByKeys}`,
      { params }
    );
  }

  getArticlesForInternalOrder(internalOrderId: number, page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('internalOrderId', internalOrderId).set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticlesForInternalOrder}`,
      filters, { params: params }
    );
  }

  getAllArticlesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllArticlesWithPagination}`,
      filters, { params: params }
    );
  }

  getAllArticleGenericsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetAllArticleGenericsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getArticleByCode(code: number): Observable<ArticleModel> {
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticleByCode}/${code}`);
  }

  getArticleById(articleId: number): Observable<ArticleModel> {
    return this._httpClient.get<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticleById}/${articleId}`);
  }

  getArticleByName(name: string): Observable<ArticleModel> {
    const itemFilterResponse = new ItemFilterModel("name", null, null, "");
    itemFilterResponse.wildcard = name;
    return this._httpClient.post<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticleByName}`, itemFilterResponse);
  }

  getArticlesForSubrentalOutputs(rentalStockContract: InventoryOutputModel, storeId: number): Observable<Array<RentalStockModel>> {
    return this._httpClient.post<Array<RentalStockModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetArticlesForSubrentalOutputs}/${storeId}`,
      rentalStockContract);
  }
  getColumnsForArticlesByTypes(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetColumnsForArticlesByTypes}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetColumnsForGeneralConsultation}`);
  }

  getColumnsForGeneralConsultationGeneric(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetColumnsForGeneralConsultationGenericAsync}`);
  }

  getFilesToArticle(articleId: number): Observable<Array<string>> {
    return this._httpClient.get<Array<string>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.GetFilesToArticle}/${articleId}`);
  }

  importArticles(articleImports: Array<ArticleImportModel>, swGeneric: number): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ImportArticles}/${swGeneric}`, articleImports);
  }


  selectMainImageAsync(articleId: number, imageNumber: number | null): Observable<ArticleModel> {
    return this._httpClient.post<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.SelectMainImageAsync}/${articleId}`, imageNumber);
  }

  setActiveArticle(articleId: number): Observable<ArticleModel> {
    return this._httpClient.put<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.SetActiveArticle}/${articleId}`,
      null);
  }

  updateArticle(articleContractModel: ArticleModel): Observable<ArticleModel> {
    return this._httpClient.put<ArticleModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.UpdateArticle}`,
      articleContractModel);
  }

  validateBalances(articleId: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ValidateBalances}/${articleId}`);
  }

  validateBalancesByEquipmentLogbook(articleId: number): Observable<boolean> {
    return this._httpClient.get<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.article.ValidateBalancesByEquipmentLogbook}/${articleId}`);
  }

}
